export default {
  HOME: '/',
  CATEGORY: '/watch/:id',
};